async function getAllClients() {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/clients?populate=image`,
    );
    return response.json();
  } catch (error) {
    throw new Error(error.message);
  }
}

export default getAllClients;
